(function () {
  'use strict';

  var roots = [];

  function reinitializeCards(root) {
    try {
      if (window.roar && typeof window.roar.loadingEffects === 'function') window.roar.loadingEffects();
      if (window.roar && typeof window.roar.handleReviews === 'function') window.roar.handleReviews();
    } catch (error) {
      // Server-rendered cards remain usable when an optional legacy enhancer fails.
    }
    try {
      if (typeof window.currenciesCallbackSpecial === 'function') window.currenciesCallbackSpecial('span.money');
    } catch (error) {
      // Prices are already rendered in the active currency.
    }
    try {
      document.dispatchEvent(new CustomEvent('milanus:catalog-products-appended', {
        bubbles: true,
        detail: { root: root, appended: root.querySelectorAll('[data-milanus-catalog-grid] > .product_item').length }
      }));
    } catch (error) {
      // The event is an integration hook, not a loading requirement.
    }
  }

  function stateKey(root) {
    return 'milanusCatalogProgressive:' + window.location.pathname + window.location.search + ':' + (root.id || 'catalog');
  }

  function setExpandedState(root, value) {
    var state = Object.assign({}, window.history.state || {});
    state[stateKey(root)] = Object.assign({}, state[stateKey(root)] || {}, value);
    window.history.replaceState(state, document.title, window.location.href);
  }

  function savedState(root) {
    return window.history.state && window.history.state[stateKey(root)];
  }

  function revealPagination(root) {
    root.classList.add('is-complete');
    root.querySelectorAll('[data-milanus-pagination]').forEach(function (pagination) { pagination.hidden = false; });
    var sentinel = root.querySelector('[data-milanus-catalog-sentinel]');
    if (sentinel) sentinel.hidden = true;
  }

  function appendDeferred(root, options) {
    options = options || {};
    if (!root || root.dataset.milanusCatalogAppending === 'true') return false;
    var grid = root.querySelector('[data-milanus-catalog-grid]');
    var template = root.querySelector('template[data-milanus-catalog-template]');
    if (!grid || !template || !template.content || !template.content.children.length) {
      revealPagination(root);
      return false;
    }
    root.dataset.milanusCatalogAppending = 'true';
    var fragment = template.content.cloneNode(true);
    var appended = fragment.children.length;
    grid.appendChild(fragment);
    template.remove();
    revealPagination(root);
    delete root.dataset.milanusCatalogAppending;
    var status = root.querySelector('[data-milanus-catalog-status]');
    if (status) status.textContent = root.getAttribute('data-loaded-text') || '';
    setExpandedState(root, { expanded: true, scrollY: window.scrollY });
    reinitializeCards(root);
    return appended > 0;
  }

  function reset(root) {
    if (!root) return;
    root.classList.remove('is-complete');
    root.classList.add('is-enhanced');
    root.querySelectorAll('[data-milanus-pagination]').forEach(function (pagination) { pagination.hidden = true; });
    var sentinel = root.querySelector('[data-milanus-catalog-sentinel]');
    var template = root.querySelector('template[data-milanus-catalog-template]');
    if (!template || !template.content || !template.content.children.length) {
      revealPagination(root);
      return;
    }
    if (sentinel) sentinel.hidden = false;
    if (root._milanusCatalogObserver) root._milanusCatalogObserver.disconnect();
    if (!window.IntersectionObserver) {
      appendDeferred(root, { fallback: true });
      return;
    }
    root._milanusCatalogObserver = new IntersectionObserver(function (entries) {
      if (!entries.some(function (entry) { return entry.isIntersecting; })) return;
      root._milanusCatalogObserver.disconnect();
      appendDeferred(root);
    }, { rootMargin: '300px 0px', threshold: 0 });
    var cards = root.querySelectorAll('[data-milanus-catalog-grid] > .product_item');
    var approachTarget = cards.length ? cards[cards.length - 1] : sentinel;
    root._milanusCatalogObserver.observe(approachTarget);
  }

  function rememberProductReturn(root, event) {
    var link = event.target.closest && event.target.closest('a[href*="/products/"]');
    if (!link || !link.closest('[data-milanus-catalog-grid]')) return;
    setExpandedState(root, {
      expanded: root.classList.contains('is-complete'),
      scrollY: window.scrollY,
      productUrl: new URL(link.getAttribute('href'), window.location.href).href
    });
  }

  function restore(root) {
    var saved = savedState(root);
    if (!saved) return;
    if (saved.expanded) appendDeferred(root, { restoring: true });
    window.requestAnimationFrame(function () {
      var productLink = saved.productUrl && Array.prototype.find.call(root.querySelectorAll('[data-milanus-catalog-grid] a[href*="/products/"]'), function (link) {
        return new URL(link.getAttribute('href'), window.location.href).href === saved.productUrl;
      });
      if (productLink) productLink.scrollIntoView({ block: 'center' });
      else if (typeof saved.scrollY === 'number') window.scrollTo(0, saved.scrollY);
    });
  }

  function initialize(root) {
    if (!root || root.dataset.milanusCatalogInitialized === 'true') return;
    root.dataset.milanusCatalogInitialized = 'true';
    roots.push(root);
    root.addEventListener('click', function (event) { rememberProductReturn(root, event); });
    reset(root);
    restore(root);
    window.setTimeout(function () {
      if (!root.classList.contains('is-complete') && !root._milanusCatalogObserver) appendDeferred(root, { fallback: true });
    }, 5000);
  }

  window.MilanusCatalogProgressive = { append: appendDeferred, reset: reset };
  document.querySelectorAll('[data-milanus-catalog-progressive]').forEach(initialize);
  window.addEventListener('pageshow', function (event) {
    if (!event.persisted) return;
    roots.forEach(function (root) { restore(root); });
  });
}());
